import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import React, { ReactNode } from 'react';
import { withRouter } from 'react-router';
import { CompleteMailComponentView } from './CompleteMailComponentView';
import { WprSpan } from '../../wpr-framework/component/controls/WprSpan';
import { HeaderComponent } from '../common/header/HeaderComponent';
import { FooterComponent } from '../common/footer/FooterComponent';

/**
 * メール送信完了コンポーネント
 */
class CompleteMailComponent extends WprBaseRouteViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new CompleteMailComponentView(), props);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
     * 描画
     */
	public onRender(): ReactNode {
		return (
			<>
				<HeaderComponent />
				<div className="step">
					<div className="wrap">
						<div className="stepper">
							<ul>
								<li className="done"><span>1</span></li>
								<li className="done"><span>2</span></li>
								<li className="done"><span>3</span></li>
								<li className="comp">
									<span>4</span>
									<p className="conf double" id="step4b">メールアドレス<br className="c-sm-br" />の登録完了</p>
								</li>
							</ul>
                  
						</div>
					</div>
				</div>
				<main className="page-4b">
					<div className="complete">
						<h2> ご登録いただいたメールアドレスへURLをお送りしました</h2>
					</div>
					<div className="mail">
						<p><WprSpan view={this.view} name="mailAddress"></WprSpan></p>
					</div>
					<div className="guide">
						<p>メールに記載のURLから、24時間以内にお申込み手続きにお進みください。</p>
					</div>
					<div className="sentence">
						<div className="headline">
							<p>メールが届かない方</p>
						</div>
						<div className="text">
							<p> メールが届かない方は、迷惑メールフォルダをまずご確認ください。</p>
							<p> どこにも受信されていない場合は、お手数ですが、はじめからお手続きをお願いいたします。</p>
						</div>
					</div>
				</main>
				<FooterComponent />
			</>
		);
	}
	// --------------------------------------------------------------------------
}

export default withRouter(CompleteMailComponent);